module.exports = __webpack_public_path__ + "static/media/logo-eng.cdd98141.svg";